import React, { lazy, Suspense } from 'react'
import { Route } from 'react-router-dom'
import { SuspenseRoot } from '@e3dc-react/shell/Elements/Suspense'
import { ExtensionConnectionTypes } from 'src/Libs/installation-extensions'

const PrivacyProtection = lazy(() => import('src/Routes/PrivacyProtection/PrivacyProtection'))
const ReferralTermsAndConditions = lazy(() => import('src/Routes/Referral/TermsAndConditions'))
const ExtensionConfirmation = lazy(() => import('src/Routes/installation-extensions/ExtensionConfirmation'))
const RedirectPage = lazy(() => import('src/Libs/e-mobility/vehicle-integration/components/manufacturer-list/RedirectPage'))

/**
 * A routes component with general routes which don't need installation context
 */
const useGeneralRoutes = (): React.ReactElement[] => {
  return [
    <Route
      key="privacy-protection"
      path="/privacy-protection"
      element={
        <Suspense fallback={<SuspenseRoot />}>
          <PrivacyProtection />
        </Suspense>
      }
    />,
    <Route
      key="referral-terms-and-conditions"
      path="/referral-terms-and-conditions"
      element={
        <Suspense fallback={<SuspenseRoot />}>
          <ReferralTermsAndConditions />
        </Suspense>
      }
    />,
    <Route
      key="ostrom-confirmation"
      path="/external-dynamic-tariff/:installationId/ostrom-confirmation"
      element={
        <Suspense fallback={<SuspenseRoot />}>
          <ExtensionConfirmation extensionName={ExtensionConnectionTypes.Ostrom} />
        </Suspense>
      }
    />,
    <Route
      key="tibber-confirmation"
      path="/external-dynamic-tariff/:installationId/tibber-confirmation"
      element={
        <Suspense fallback={<SuspenseRoot />}>
          <ExtensionConfirmation extensionName={ExtensionConnectionTypes.Tibber} />
        </Suspense>
      }
    />,
    <Route
      key="luox-confirmation"
      path="/external-dynamic-tariff/:installationId/luox-confirmation"
      element={
        <Suspense fallback={<SuspenseRoot />}>
          <ExtensionConfirmation extensionName={ExtensionConnectionTypes.Luox} />
        </Suspense>
      }
    />,
    <Route
      key="vehicle-integration-redirect-page"
      path="/vehicle-integration"
      element={
        <Suspense fallback={<SuspenseRoot />}>
          <RedirectPage />
        </Suspense>
      }
    />,
  ]
}

export default useGeneralRoutes
